// extracted by mini-css-extract-plugin
export default {"container":"UserStatus_container__TllMm","header":"UserStatus_header__4+frL","labelWrap":"UserStatus_labelWrap__qIfFo"};